import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./MobileFooter.module.css";
import { CDN_LINK } from "@globalConfig";
import useIsFirstInteraction from "@hooks/useIsFirstInteraction";
import useHelpers from "@hooks/useHelpers";
var MobileFooter = function MobileFooter() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isFirstInteraction = useIsFirstInteraction();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var year = new Date().getFullYear();
  return /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.upperSection
  }, isFirstInteraction && /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/safety.svg",
    alt: "i",
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("p", null, t("syarah_registered_company_ministry_trade_mobile", {
    ns: "web_footer"
  })), isFirstInteraction && /*#__PURE__*/React.createElement("div", {
    className: stl.footerWithVat
  }, /*#__PURE__*/React.createElement("a", {
    className: stl.vatLink,
    href: CDN_LINK + "/assets/bundles/GAZT_VAT_Certificate.pdf",
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    width: "30px",
    height: "38px",
    src: CDN_LINK + "/assets/images/Vat.svg",
    alt: "vat icon"
  })), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/saudi_elm.svg",
    alt: "saudi_elm icon",
    width: "262px",
    height: "44px"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.lowerSection
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.paymentMethods
  }, /*#__PURE__*/React.createElement("span", {
    className: stl.paymentTitle
  }, t("safe_payment_methods", {
    ns: "web_footer"
  })), /*#__PURE__*/React.createElement("ul", {
    className: stl.paymentRow
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Visadark",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-mc",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-apple_pay",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-BankTransfer",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  })))), /*#__PURE__*/React.createElement("ul", {
    className: stl.paymentRow
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/bnpl_tabby_logo.png",
    className: stl.bnplIcon,
    alt: "tabby"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/bnpl_tamara_logo.png",
    className: stl.bnplIcon,
    alt: "tamara"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/bnpl_amwal_logo.png",
    className: stl.bnplIcon,
    alt: "amwal"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Mada",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path6"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path7"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path8"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path9"
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "icon-Sadad",
    style: {
      fontSize: "60px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  }))))), /*#__PURE__*/React.createElement("p", {
    className: stl.copyright
  }, t("rights_reserved_syarah_ltd_year", {
    ns: "web_footer",
    year: year
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.links
  }, /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    href: createUrl("/terms-landing"),
    className: "interActiveGray"
  }, t("terms_conditions", {
    ns: "web_footer"
  })), " | ", /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    href: createUrl("/privacy-policy"),
    className: "interActiveGray"
  }, t("privacy_policy", {
    ns: "web_footer"
  })), " | ", /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    href: createUrl("/return-policy"),
    className: "interActiveGray"
  }, tShort("return_policy"))))));
};
export default MobileFooter;